'use strict';

var _ = require('lodash');
var d3 = require('d3');

/**
 * Scales Service
 *
 * Used for adjusting scales for two axis (ex. when chart has two yAxis)
 *
 * @constructor
 */
var ScalesService = function ScalesService() {
  /**
   * Calculates new 'zero' level
   * @param {number} x1
   * @param {number} y1
   * @param {number} x2
   * @param {number} y2
   * @returns {Function}
   */
  function getInverseFunction(x1, y1, x2, y2) {
    var a = (y1 - y2) / (x1 - x2);
    var b = y1 - a * x1;
    return function (x) {
      return (x - b) / a;
    };
  }

  /**
   * Adjust scales to be on the same level
   * @param {Function} scale1
   * @param {Function} scale2
   */
  function adjustScales(scale1, scale2) {
    var s10 = scale1(0);
    var s20 = scale2(0);
    var smaller;
    var scaleToModify;
    if (s10 > s20) {
      smaller = s20;
      scaleToModify = scale1;
    } else {
      smaller = s10;
      scaleToModify = scale2;
    }
    var x1 = scaleToModify.domain()[1];
    var y1 = scaleToModify(x1);
    var f = getInverseFunction(x1, y1, 0, smaller);
    var newX1 = f(scale1.range()[0]).toFixed(5);
    scaleToModify.domain([newX1, x1]);
  }
  function createPositiveNegativeBarScale(params, data, dataKey) {
    var x = d3.scale.ordinal().domain(_.map(data, dataKey)).rangeBands([0, params.width], 0.1, 0.05);
    var circleRadius = Math.min(x.rangeBand() / 8, 10);
    var circleData = _.transform(data, function (result, element) {
      result.push.apply(result, _.map(element.circles, 'value'));
    }, []);
    var minCircleData = _.min(circleData);
    var yMin = d3.min(data, function (d) {
      return _.min(d.data);
    });
    yMin = yMin > 0 ? 0 : yMin;
    var maxCircleData = _.max(circleData);
    var yMax = d3.max(data, function (d) {
      return _.max(d.data);
    });
    yMax = yMax < 0 ? 0 : yMax;
    var yDomain;
    function getDelta(circleQuantity) {
      var range = maxCircleData - minCircleData;
      return ((params.height + circleRadius * circleQuantity) / params.height * range - range) / circleQuantity;
    }
    if (maxCircleData + getDelta(2) >= yMax && minCircleData - getDelta(2) <= yMin) {
      var halfRange = (maxCircleData - minCircleData) / 2;
      var center = maxCircleData - halfRange;
      var newHalfRange = (maxCircleData - minCircleData) / ((params.height - circleRadius * 2) / params.height) / 2;
      yDomain = [center - newHalfRange, center + newHalfRange];
    } else if (maxCircleData + getDelta(1) >= yMax) {
      yDomain = [yMin, yMin + (maxCircleData - yMin) / ((params.height - circleRadius) / params.height)];
    } else if (minCircleData - getDelta(1) <= yMin) {
      yDomain = [yMax - (yMax - minCircleData) / ((params.height - circleRadius) / params.height), yMax];
    } else {
      yDomain = [yMin, yMax];
    }
    var y = d3.scale.linear().domain(yDomain).rangeRound([params.height, 0]);
    return {
      xScale: x,
      yScale: y
    };
  }
  return {
    adjustScales: adjustScales,
    createPositiveNegativeBarScale: createPositiveNegativeBarScale
  };
};
ScalesService.$inject = [];
module.exports = ScalesService;